import {HeaderTitle, HeaderWrapper} from '@components/commons/header/style.ts'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {routes} from '@utilities/constants/routes.tsx'
import {SearchBar} from '@components/ui/search-bar/SearchBar.tsx'
import useWindowDimensions from '@hooks/useWindowDimensions.ts'
import {useMemo, useState} from 'react'

export const Header = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {width} = useWindowDimensions()
    const isMobile = useMemo(() => width < 768, [width])
    const [isSearchOpen, setIsSearchOpen] = useState(false)

    return (
        <HeaderWrapper $isSearchOpen={isSearchOpen}>
            {(!isMobile || !isSearchOpen) && (
                <HeaderTitle
                    onClick={() => {
                        navigate(routes.MEASURES.path)
                    }}
                >
                    {t('commons:title')}
                </HeaderTitle>
            )}

            <SearchBar isOpen={isSearchOpen} onToggleSearch={setIsSearchOpen} isMobile={isMobile} />
            {/*  <MobileMenu variant="neutral" onClick={() => setIsSidebarOpen(true)}>
                        <MenuIcon />
                    </MobileMenu>

                    <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)}>
                        <Flexbox direction="column" gap={5} align="center" justify="center" fullWidth>
                            <Button
                                fullWidth
                                variant="primaryGhost"
                                onClick={() => {
                                    setIsSidebarOpen(false)
                                    navigate(routes.MEASURES.path)
                                }}
                            >
                                {t('measures:measure')}
                            </Button>
                        </Flexbox>
                    </Sidebar>*/}
        </HeaderWrapper>
    )
}
